import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { UserCmsComponent } from './user-cms/user-cms.component';
import { UserDomainComponent } from './user-domain/user-domain.component';
import { UserComponent } from './user/user.component';
import { UsersComponent } from './users.component';
import { UserVaultComponent } from '@app/authorized/usersRolesManagement/usersManagement/users/user-vault/user-vault.component';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';
import { UserGitServerComponent } from './user-git-server/user-git-server.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        UserComponent,
        UserCmsComponent,
        UserDomainComponent,
        UsersComponent,
        UserVaultComponent,
        UserGitServerComponent        
    ],
    entryComponents: [
        UserComponent,
        UserCmsComponent,
        UserDomainComponent,
        UsersComponent,
        UserVaultComponent,
        UserGitServerComponent
    ],
    exports: [
        UserComponent,
        UserCmsComponent,
        UserDomainComponent,
        UsersComponent,
        UserVaultComponent,
        UserGitServerComponent
    ],
    providers: [VaultConnectionService]
})
export class UsersModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/users.module.ts